import { GET_LOOTBOX_SALES } from '@/api/query'
import { Skeleton } from '@chakra-ui/react'
import { ProgressBar } from './ProgressBar'
import { useQuery } from '@apollo/client'

export const NumberOfSoldLootboxes = ({
  id,
  limit,
  version,
}: {
  id: string
  limit: number
  version?: 'card' | 'banner' | 'modal'
}) => {
  const { data, loading, error } = useQuery(GET_LOOTBOX_SALES, {
    variables: {
      id,
    },
  })

  const isCardVersion = !version || version === 'card'
  const isModalVersion = version === 'modal'

  if (loading || error) {
    return (
      <Skeleton
        rounded={isCardVersion ? 'lg' : 'xl'}
        h={isCardVersion ? '37px' : isModalVersion ? '68px' : '61px'}
        w={'full'}
        startColor="ninja.400"
        endColor="ninja.500"
      />
    )
  }

  return <ProgressBar totalCount={data?.lootboxSale?.salesCount || 0} totalLimit={limit} version={version} />
}
